export default "__VITE_ASSET__b45a4222__"